export default () => {
  try {
    window.friendbuyAPI = window.friendbuyAPI || [];

    // registers your merchant using your merchant ID found in the
    // retailer app https://retailer.friendbuy.io/settings/general
    // friendbuyAPI.merchantId = "<?= $this->getDI()->get('config')->olive->friendbuy->merchantId ?>";
    friendbuyAPI.merchantId = TYROOLA.globals.friendbuyMerchantId;
    friendbuyAPI.push(['merchant', friendbuyAPI.merchantId]);

    // load the merchant SDK and your campaigns
    (function (f, r, n, d, b, u, y) {
      while ((u = n.shift())) {
        (b = f.createElement(r)), (y = f.getElementsByTagName(r)[0]);
        b.async = 1;
        b.src = u;
        b.onerror = (error) => {
          console.log(error);
        };

        var windowErrorHandler = (event) => {
          event.preventDefault();
          console.log(event);
        };
        window.addEventListener('error', windowErrorHandler);

        y.parentNode.insertBefore(b, y);
      }
    })(document, 'script', [
      'https://static.fbot.me/friendbuy.js',
      'https://campaign.fbot.me/' + friendbuyAPI.merchantId + '/campaigns.js',
    ]);
  } catch (err) {
    console.log(err);
  }
};
